import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useTranslation } from 'next-i18next'

import { ButtonPrimary } from '~/components/Buttons/ButtonPrimary'
import { ButtonSize } from '~/components/Buttons/types'
import { InputV2 } from '~/components/InputV2'
import { useAppSelector, useAppDispatch } from '~/redux/hooks'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

import { resetCaptcha, selectCaptcha, setCaptcha } from '../slices/recaptcha.slice'

export default function CaptchaChallenge({
  btnSize,
  loading,
  handleSubmit,
  isLandingPage,
  hideSubmitBtn,
  className,
}: {
  btnSize?: ButtonSize
  loading: boolean
  handleSubmit?: () => void
  isLandingPage?: boolean
  hideSubmitBtn?: boolean
  className?: string
}) {
  const { t } = useTranslation(['common'])
  const captcha = useAppSelector(selectCaptcha)
  const dispatch = useAppDispatch()
  const router = useRouter()
  const size = btnSize ?? 'small'
  const showSubmitBtn = !hideSubmitBtn

  const imgSrc = `data:image/svg+xml;utf8,${encodeURIComponent(captcha.challenge)}`
  const wrapperClass = `mb-2 ${isLandingPage ? 'px-3' : ''} ${className ?? ''}`

  const imageWidth = isLandingPage ? 100 : 150
  const flexItemsClass = isLandingPage ? 'items-baseline' : 'items-start'

  useEffect(() => {
    const handleRouteChange = (): void => {
      dispatch(resetCaptcha())
    }

    router.events.on('routeChangeStart', handleRouteChange)
    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [dispatch, router.events])

  return (
    <div className={wrapperClass}>
      <div className={`flex ${flexItemsClass} space-x-3`}>
        <ResponsiveImage imageClassName="rounded h-14 mt-px bg-white" src={imgSrc} width={imageWidth} />
        <div className="w-45 lg:w-85">
          <InputV2
            autoComplete="off"
            className="w-full"
            isCaptchaInput
            label="Answer"
            name="captchaAnswer"
            setValue={(val) => dispatch(setCaptcha({ ...captcha, answer: val }))}
            type="text"
            value={captcha.answer}
          />
        </div>
      </div>
      {showSubmitBtn && (
        <ButtonPrimary disabled={loading} isFullWidth onClick={handleSubmit} size={size} type="submit">
          {t('common:submit')}
        </ButtonPrimary>
      )}
    </div>
  )
}
